const checkCurrency = (currency) => {
  return /[가-힣]|won/gi.test(currency);
};
const setFormatDate = (date) => {
  return date.toLocaleDateString("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).replaceAll("-", ".");
};
const setFormatMonth = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}.${month}`;
};
const setFormatPrice = (value) => {
  const parseValue = value === "" || value.length < 1 ? "" : parseInt(value, 10);
  console.log("parseValue", parseValue);
  return parseValue.toLocaleString();
};
const formatYYYYMMDD = (raw) => {
  const digits = raw.replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 4) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 4)}.${digits.slice(4)}`;
  return `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6)}`;
};
const changeFormat = (date) => {
  if (!date) return void 0;
  const [y, m, d] = date.split(".");
  return new Date(Number(y), Number(m) - 1, d ? Number(d) : 1);
};
const dateCheck = ({
  dateVal,
  monthFlag = false,
  startYear = "1900",
  endYear = "2100"
}) => {
  let strTemp = "";
  let strLast = "";
  let strChk = 0;
  for (let i = 0; i < dateVal.length; i++) {
    strTemp = dateVal.substring(i, i + 1);
    if (strTemp >= "0" && strTemp <= "9") {
      strLast = strLast + strTemp;
    }
  }
  if (Number(dateVal) > 0) {
    if (strLast.substring(0, 4) >= startYear && strLast.substring(0, 4) <= endYear) {
      strChk = 1;
    }
    const isValidMonth = /^(0[1-9]|1[0-2])$/;
    if (isValidMonth.test(strLast.substring(4, 6))) {
      strChk = strChk + 1;
    }
    if (monthFlag) {
      return strChk === 2 ? dateVal : "N";
    }
    if (strLast.substring(6, 8) >= "01" && strLast.substring(6, 8) <= "31") {
      if (strLast.substring(6, 8).length == 2) {
        strChk = strChk + 1;
      }
    }
    if (strChk === 3) {
      const year = Number(strLast.substring(0, 4));
      const month = Number(strLast.substring(4, 6));
      const day = Number(strLast.substring(6, 8));
      dateVal = strLast.substring(0, 4) + "-" + strLast.substring(4, 6) + "-" + strLast.substring(6, 8);
      if (day >= 1 && day <= 31) {
        if (month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12) {
          return dateVal;
        } else {
          if (month == 2) {
            if (year % 4 != 0 || year % 100 == 0 && year % 400 != 0) {
              if (day == 29 || day == 30 || day == 31) {
                return "N";
              } else {
                return dateVal;
              }
            } else {
              return dateVal;
            }
          } else {
            if (day == 31) {
              return "N";
            } else {
              return dateVal;
            }
          }
        }
      } else if (month > 12) {
        return "N";
      } else if (day > 31) {
        return "N";
      } else {
        return dateVal;
      }
    } else {
      return "N";
    }
  } else {
    return "N";
  }
};
const ASSET_BASE = "/";
const asset = (path) => {
  const base = ASSET_BASE.endsWith("/") ? ASSET_BASE : `${ASSET_BASE}/`;
  const p = path.startsWith("/") ? path.slice(1) : path;
  return `${base}${p}`;
};
let returnFocusEl = null;
const saveReturnFocusEl = (el) => {
  if (el) {
    returnFocusEl = el;
    return;
  }
  const activeEl = document.activeElement;
  returnFocusEl = activeEl instanceof HTMLElement ? activeEl : null;
};
const restoreReturnFocus = (fallbackEl) => {
  const target = returnFocusEl && returnFocusEl.isConnected ? returnFocusEl : fallbackEl;
  requestAnimationFrame(() => {
    target?.focus({ preventScroll: true });
  });
  returnFocusEl = null;
};
const common = {
  checkCurrency,
  setFormatDate,
  setFormatMonth,
  setFormatPrice,
  formatYYYYMMDD,
  dateCheck,
  asset,
  changeFormat,
  saveReturnFocusEl,
  restoreReturnFocus
};

export { common };
